import React from 'react'
import { Grid } from '@material-ui/core'
import VulnerStatisticsCard from '../../modules/vulner_statistics_card/vulner_statistics_card'
import strings from '../../strings/strings.json'
import styles from './vulner_statistics.module.css'

export default function VulnerStatistics(props) {
  return (
    <div className='shadow_white rounded-2xl'>
      <Grid container>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <div className={`${styles.container}`}>
            <VulnerStatisticsCard
              isPercent={true}      //vulnerability percent
              icon="dashboard-2-fill"
              title={strings.general_riskTaking}
              num={props.vulnerability_rate}
            />
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <div className={`${styles.container} ${styles.vulnerabilities_container}`}>
            <VulnerStatisticsCard
              icon="bug_security"
              title={strings.fileDetail_vulnerabilities}
              num={props.vulnerabilities}
            />
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <div className={`${styles.container} ${styles.sec_risk_container}`}>
            <VulnerStatisticsCard
              icon="bug_vulnerabilities"
              title={strings.fileDetail_secRisk}
              num={props.vulnerability_risk}
            />

          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <div className={`${styles.container}`}>
            <VulnerStatisticsCard
              icon="vulns_library"
              title={strings.general_libraryVulns}
              num={props.vulnerability_libs}
            />
          </div>
        </Grid>
      </Grid>
    </div>
  )
}